import * as React from 'react';

import Loader from 'components/atoms/Loader';

export type NoticePropType = {
	text?: string;
};

const Notice = ({ text }: NoticePropType) => {
	return (
		<div className="m-notice">
			{text && (
				<span>
					<p className="m-notice__text">{text}</p>
				</span>
			)}

			<div className="m-notice__loader">
				<div className="a-loader js-a-loader a-loader--white">
					<Loader modifier="white" hasContainer={false} />
				</div>
			</div>
		</div>
	);
};

Notice.displayName = 'Notice';

export default Notice;
